export const fetchFromVolatileServer = (
  input: RequestInfo | URL,
  init?: RequestInit,
  retries: number = 3,
): ReturnType<typeof fetch> =>
  fetch(input, init).catch((error) => {
    //? This is useful for debugging in the pipelin, so it should stay
    // eslint-disable-next-line no-console
    console.log("fetchFromVolatileServer", retries, error?.code, input);
    if (retries > 0)
      return new Promise((res) =>
        setTimeout(
          () => res(fetchFromVolatileServer(input, init, retries - 1)),
          1000,
        ),
      );
    // If this is some other type of error or there are no retries left, rethrow error
    throw error;
  });
